import { Box, Button, Flex, Heading, HStack, Image, Stack, Text } from "@chakra-ui/react";
import { useEthers } from "@usedapp/core";
import BigNumber from "bignumber.js";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { I18N_NAMESPACE } from "../../../core/constants/i18n";
import { IMoralisNft } from "../../../core/models/nft";
import { Quote } from "../../../core/models/quote";
import { formatNumber } from "../../../core/utils/number";
import { useAppSelector } from "../../../store/hook";

interface Props {
  nft: IMoralisNft | undefined;
  quote: Quote;
  onPayInFour: (quote: Quote) => void;
  onPayFull: (quote: Quote) => void;
}

export const PurchaseForm = React.memo(({ nft, quote, onPayInFour, onPayFull }: Props) => {
  const { account } = useEthers();
  const { t } = useTranslation([I18N_NAMESPACE.ASSET_DETAIL]);

  const supportedTokens = useAppSelector((state) => state.token.supportedTokens);
  const token = useMemo(
    () => supportedTokens.byId[quote.take.asset_type.token_address],
    [quote.take.asset_type.token_address, supportedTokens.byId]
  );
  const price = useMemo(
    () => (!!quote?.take?.value ? new BigNumber(quote?.take.value).div(Math.pow(10, token.decimals)).toNumber() : 0),
    [quote.take.value, token]
  );

  return (
    <>
      <Box>
        <Box>
          <Heading size="sm">{t("Price")}</Heading>
          <Flex marginTop="12px">
            <Flex background="#f8f8f8" borderRadius="15px" padding="8px 24px" alignItems="center">
              <Image src={token?.logoUrl} height="24px" width="24px" marginRight="8px" />
              <Text fontWeight="700" fontSize={"20px"}>
                <Text as="span">{formatNumber(price)}</Text>
              </Text>
            </Flex>
          </Flex>
        </Box>

        <Box marginTop={6}>
          <Heading size="sm">{t("Purchase options")}:</Heading>
          <Stack direction={{ base: "column", lg: "row" }} marginTop="16px" spacing={4}>
            <Button colorScheme="blue" variant="outline" onClick={() => onPayInFour(quote)}>
              {t("Pay in 4")}{" "}
              <Flex alignItems="center">
                <Image src={token?.logoUrl} height="22px" width="22px" margin="0px 6px" />
                <Text>
                  <Text as="span">
                    {formatNumber(
                      new BigNumber(quote?.take.value || 0).div(4).div(Math.pow(10, token.decimals)).toNumber()
                    )}
                  </Text>
                </Text>
              </Flex>
            </Button>

            <Button colorScheme="blue" variant="outline" onClick={() => onPayFull(quote)}>
              {t("Pay full")}{" "}
              <Flex alignItems="center">
                <Image src={token?.logoUrl} height="22px" width="22px" margin="0px 6px" />
                <Text>
                  <Text as="span">{formatNumber(price)}</Text>
                </Text>
              </Flex>
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
});
